'use client';
import type { FC, ReactNode } from 'react';

import { cn } from '@wwe-portal/ui/lib/lib';

import { ClickableDiv } from '../button';
import { IcoMoonIcon } from '../icons/icomoon';

import {
  Tooltip,
  TooltipArrow,
  TooltipContent,
  TooltipPortal,
  TooltipTrigger,
} from './tooltip';
import { useTooltipOpen } from './use-tooltip';

export const InfoTooltip: FC<{
  content: ReactNode;
  titleClassName?: string;
  iconClassName?: string;
  contentProps?: React.ComponentPropsWithoutRef<typeof TooltipContent>;
  hasPortal?: boolean;
}> = ({
  content,
  titleClassName,
  iconClassName,
  contentProps,
  hasPortal = true,
}) => {
  const { open, onOpenChange, trigger } = useTooltipOpen();
  const contentElement = (
    <TooltipContent
      collisionPadding={20}
      side="bottom"
      className="text-text500 w-[240px]"
      {...contentProps}
    >
      {content}
      <TooltipArrow />
    </TooltipContent>
  );
  return (
    <Tooltip onOpenChange={onOpenChange} open={open}>
      <TooltipTrigger asChild>
        <ClickableDiv
          className={cn(
            'bg-toolTipBgColor flex size-5 items-center justify-center rounded-full',
            titleClassName
          )}
          onClick={trigger}
        >
          <IcoMoonIcon
            className={cn('size-2.5', iconClassName)}
            iconName="info-2"
          />
        </ClickableDiv>
      </TooltipTrigger>
      {hasPortal ? (
        <TooltipPortal>{contentElement}</TooltipPortal>
      ) : (
        contentElement
      )}
    </Tooltip>
  );
};
